import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { getFileStreamsCache } from '../file-streams-cache';
import { mapMediaFileToFileState } from '../models/file-state';
import { fromObservable } from '../utils/mediaSubscribable';
export var collectionCache = {};
var createCacheEntry = function createCacheEntry() {
  return {
    items: [],
    subject: new ReplaySubject(1),
    isLoadingNextPage: false
  };
};
export var CollectionFetcher = /*#__PURE__*/function () {
  function CollectionFetcher(mediaStore) {
    _classCallCheck(this, CollectionFetcher);
    this.mediaStore = mediaStore;
  }
  _createClass(CollectionFetcher, [{
    key: "createFileStateObserver",
    value: function createFileStateObserver(id, details) {
      var subject = new ReplaySubject(1);
      var mediaFile = _objectSpread({
        id: id
      }, details);
      var fileState = mapMediaFileToFileState({
        data: mediaFile
      });
      subject.next(fileState);
      return subject;
    }
  }, {
    key: "populateCache",
    value: function populateCache(items) {
      var _this = this;
      items.forEach(function (item) {
        var fileStream = _this.createFileStateObserver(item.id, item.details);
        getFileStreamsCache().set(item.id, fileStream);
      });
    }
  }, {
    key: "removeFromCache",
    value: function removeFromCache(id, collectionName) {
      var collectionCacheIndex = collectionCache[collectionName].items.findIndex(function (item) {
        return item.id === id;
      });
      if (collectionCacheIndex === -1) {
        return;
      }
      getFileStreamsCache().remove(id);
      collectionCache[collectionName].items.splice(collectionCacheIndex, 1);
    }
  }, {
    key: "getItems",
    value: function getItems(collectionName, params, traceContext) {
      var _this2 = this;
      if (!collectionCache[collectionName]) {
        collectionCache[collectionName] = createCacheEntry();
      }
      var collection = collectionCache[collectionName];
      var subject = collection.subject;
      this.mediaStore.getCollectionItems(collectionName, _objectSpread(_objectSpread({}, params), {}, {
        details: 'full'
      }), traceContext).then(function (items) {
        var _items$data = items.data,
          contents = _items$data.contents,
          nextInclusiveStartKey = _items$data.nextInclusiveStartKey;
        _this2.populateCache(contents);
        // It's hard to merge two together, so we just take what's came from the server.
        // Since we load only one page > 2 pages will be ditched from the cache.
        collection.items = items.data.contents;
        collection.nextInclusiveStartKey = nextInclusiveStartKey;
        subject.next(collection.items);
      }).catch(function (error) {
        return subject.error(error);
      });
      return fromObservable(subject);
    }
  }, {
    key: "removeFile",
    value: function () {
      var _removeFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, collectionName, occurrenceKey, traceContext) {
        var collection;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
              case 2:
                this.removeFromCache(id, collectionName);
                collection = collectionCache[collectionName];
                collection.subject.next(collection.items);
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function removeFile(_x, _x2, _x3, _x4) {
        return _removeFile.apply(this, arguments);
      }
      return removeFile;
    }()
  }, {
    key: "loadNextPage",
    value: function () {
      var _loadNextPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(collectionName, params, traceContext) {
        var collection, isLoading, _collectionCache$coll, inclusiveStartKey, currentItems, subject, response, _response$data, contents, nextInclusiveStartKey, newItems, items;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                collection = collectionCache[collectionName];
                isLoading = collection ? collection.isLoadingNextPage : false;
                if (!(!collection || !collection.nextInclusiveStartKey || isLoading)) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                collection.isLoadingNextPage = true;
                _collectionCache$coll = collectionCache[collectionName], inclusiveStartKey = _collectionCache$coll.nextInclusiveStartKey, currentItems = _collectionCache$coll.items, subject = _collectionCache$coll.subject;
                _context2.next = 8;
                return this.mediaStore.getCollectionItems(collectionName, _objectSpread(_objectSpread({}, params), {}, {
                  inclusiveStartKey: inclusiveStartKey,
                  details: 'full'
                }), traceContext);
              case 8:
                response = _context2.sent;
                _response$data = response.data, contents = _response$data.contents, nextInclusiveStartKey = _response$data.nextInclusiveStartKey;
                this.populateCache(contents);
                newItems = response.data.contents;
                items = [].concat(_toConsumableArray(currentItems), _toConsumableArray(newItems));
                subject.next(items);
                collectionCache[collectionName] = {
                  items: items,
                  nextInclusiveStartKey: nextInclusiveStartKey,
                  subject: subject,
                  isLoadingNextPage: false
                };
              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function loadNextPage(_x5, _x6, _x7) {
        return _loadNextPage.apply(this, arguments);
      }
      return loadNextPage;
    }()
  }]);
  return CollectionFetcher;
}();